import { MdClose } from "react-icons/md";

export const DisclaimerModel = ({
  setDisclaimerModal,
}) => {
  return (
    <>
      <div className="fixed top-0 right-0 left-0 z-50 w-full h-full bg-black bg-opacity-50">
        <div className="bg-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-xl rounded-[10px] w-[90%] sm:w-[450px] md:w-[500px] lg:w-[600px] flex flex-col max-h-[70vh] md:max-h-[50vh]">
          {/* Header */}
          <div className="flex flex-shrink-0 justify-between items-center px-5 py-2 text-xl rounded-t-2xl md:px-3 xl:px-5 xl:py-3 font-Poppins">
            <div className="text-[18px] xl:text-xl text-gray-900">
              Disclaimer
            </div>
            <button onClick={() => setDisclaimerModal(false)}>
              <MdClose className="text-2xl text-gray-500 hover:text-black" />
            </button>
          </div>
          <hr />
          {/* Scrollable Content */}
          <div
            className="overflow-y-auto flex-1 px-4 py-6 sm:px-6 lg:px-8"
            >
              Welcome Cure is currently serving Schengen Countries, USA, UK, South Africa & India with its Global Doc-on-Call (G-DoC) offering.
Welcome Cure aims to keep adding more and more countries for the G-DoC service and better coverage and shall hence update the same from time to time.
There could be many other countries apart from the ones mentioned above. For more information and clarity on the active country list for the Welcome Cure's G-DoC service you may call us on  <br/>Derick Fernandes - <span className="text-blue-500"><a href="tel:+91 7400383759"> +91 74003 83759</a></span>
          </div>
        </div>
      </div>
    </>
  );
};
